module.exports = __webpack_public_path__ + "static/img/consumer-h5-4.1e96413.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/consumer-h5-4.png
// module id = pGRX
// module chunks = 34